import React from 'react';
import type { FC, ReactNode } from 'react';

import { type Field, FieldType } from '@/api/types';
import { PictureIcon } from '@/common/picture-icon';
import { TextIcon } from '@/common/text-icon';

interface FieldCardProps {
    field: Field;
    quickAction?: ReactNode;
    linkedLayers?: ReactNode;
    button?: ReactNode;
    onClick?: () => void;
}

export const FieldCard: FC<FieldCardProps> = ({
    field,
    quickAction,
    button,
    linkedLayers,
    onClick,
}) => {
    return (
        // biome-ignore lint/a11y/useKeyWithClickEvents: needs improvement for accessibility
        <div
            className={`bg-gray-130 rounded align-top flex flex-col gap-2 transition-opacity ${onClick ? 'cursor-pointer hover:opacity-80' : ''}`}
            onClick={onClick}
        >
            <div className="p-3 rounded align-top flex flex-row gap-2">
                {field.type === FieldType.Image ? <PictureIcon /> : <TextIcon />}
                <div className="flex flex-col text-sm text-white w-full">
                    <p>{field.name}</p>
                    {linkedLayers}
                </div>
                {quickAction}
            </div>
            {button && <div className="px-3 pb-3 w-full flex flex-row">{button}</div>}
        </div>
    );
};
